import * as React from "react";
import { IconProps } from "./types";

export const ArrowNarrowLeftIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M20 12H4M4 12L10 18M4 12L10 6"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowNarrowLeftIcon as React.FunctionComponent).displayName =
  "ArrowNarrowLeftIcon";

export default ArrowNarrowLeftIcon;
